import styled from "styled-components";
import { MOBILE_WIDTH, TABLET_WIDTH } from "datastake-daf/src/constants/Style";

const Style = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;

  .flex-r {
    display: flex;
  }

  .flex-c {
    display: flex;
    flex-direction: column;
  }

  .justify-center {
    justify-content: center;
  }

  .select-navbar {
    padding: 0 .75rem;
    border-right: 2px solid #EAECF0;
    border-left: 2px solid #EAECF0;

    div {
      width: 4.625rem;
      user-select: none;
      font-size: .875rem;
      font-weight: 500;
      text-align: center;
      color: #193E61; 
      cursor: pointer;
    }

    .country-cont {
      justify-content: center;
      gap: 0.6rem;

      .flex-c {
        width: fit-content;
      }

      img {
        width: 20px;
        height: 14px;
      }

      span {
        color: $gray-100;
        font-size: 14px;
      }
    }

    &.bordered {
      .country-cont {
        img {
          width: 14px;
          height: 14px;
          border-radius: 100%;
        }
      }
    }
  }

  .select-options {
    position: absolute;
    width: 100%;
    top: 55px;
    left: 0;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
    padding: .75rem 0;
    z-index: 100;
    animation: .3s fade forwards;

    &.not-toggled {
      animation: .3s fadeOut forwards;
    }

    @media (${TABLET_WIDTH}) {
      top: 50px;
    }

    @media (${MOBILE_WIDTH}) {
      top: 3.5rem;
    }

    .value {
      padding: .75rem 0rem;
      margin: 0 .75rem;
      text-align: center;
      font-size: 1rem;
      font-weight: 500;
      cursor: pointer;
      user-select: none;

      &.active-value {
        background-color: #265A80;
        color: white;
      }
    }
  }

  @keyframes fade {
    0% { opacity: 0; }
    100% { opacity: 1; }
  }

  @keyframes fadeOut {
    0% { opacity: 1; }
    100% { opacity: 0; }
  }
`;

export default Style;
